import { useInfiniteQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import type {
  ContentSectionConfig,
  TopicContentsPage,
} from "../../@types/portalAluno";
import { PORTAL_TOPIC_PAGE_SIZE } from "../../config/portalAluno/constants";
import { getSectionTopicContentsPage } from "../../services/portalAluno/topics/topicsService";
import type { ApplicationState } from "../../store";

export const portalTopicContentsQueryKey = (
  idUsuario?: number,
  topicType?: string,
  topicId?: number | null
) => ["portal-aluno", "tema-conteudos", idUsuario, topicType, topicId];

const useTopicContents = (
  section?: ContentSectionConfig,
  topicId?: number | null
) => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;

  return useInfiniteQuery<TopicContentsPage>({
    enabled: Boolean(idUsuario && section && topicId),
    queryKey: portalTopicContentsQueryKey(
      idUsuario,
      section?.topicType,
      topicId
    ),
    queryFn: ({ pageParam = 0 }) =>
      getSectionTopicContentsPage(
        section as ContentSectionConfig,
        topicId as number,
        pageParam
      ),
    getNextPageParam: (lastPage, allPages) =>
      lastPage.itemCount < PORTAL_TOPIC_PAGE_SIZE
        ? undefined
        : allPages.length * PORTAL_TOPIC_PAGE_SIZE,
  });
};

export default useTopicContents;
